import { render, staticRenderFns } from "./CaseModule.vue?vue&type=template&id=52eef89e&scoped=true"
import script from "./CaseModule.vue?vue&type=script&lang=js"
export * from "./CaseModule.vue?vue&type=script&lang=js"
import style0 from "./CaseModule.vue?vue&type=style&index=0&id=52eef89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eef89e",
  null
  
)

export default component.exports